import Checkbox from './Checkbox'
export type { CheckboxProps } from './Checkbox'
export default Checkbox
